import { DecimalPipe, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccountService } from '../../../../Services/Accounts/account.service';

@Component({
  selector: 'app-old-metal',
  standalone: true,
  imports: [NgFor, NgIf, DecimalPipe],
  templateUrl: './old-metal.component.html',
  styleUrl: './old-metal.component.css'
})
export class OldMetalComponent implements OnChanges {
  @Input() firmId: any;
  @Input() fromDate: string = '';
  @Input() toDate: string = '';
  @Output() balancesLoaded = new EventEmitter<any[]>();

  isLoading = false;
  transactions: any[] = [];
  openingBalance = 0;
  oldmetalSummary = {
    title: 'Metal',
    total: 0,
  };

  summary = {
    amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 }
  };

  // accordion
  accordionState = {
    oldmetal: true,
  };

  constructor(private accountService: AccountService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['firmId'] || changes['fromDate'] || changes['toDate']) {
      this.loadOldMetal();
    }
  }

  loadOldMetal() {
    this.isLoading = true;
    const params = {
      firm_id: this.firmId,
      from_date: this.fromDate,
      to_date: this.toDate
    };

    this.accountService.getDaybookCashflow(params).subscribe({
      next: (res: any) => {
        this.transactions = res.data.old_metal_transactions || [];
        this.openingBalance = 0;
        this.calculateSummary();
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading old metal data', err);
        this.isLoading = false;
      }
    });
  }

  calculateSummary() {
    // Reset summary
    this.summary = {
      amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
      amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 }
    };

    this.transactions.forEach(t => {
      // Net values directly in amount_in
      this.summary.amount_in.cash += (t.cash || 0);
      this.summary.amount_in.card += (t.card || 0);
      this.summary.amount_in.online += (t.online || 0);
      this.summary.amount_in.total += (t.total || 0);
    });

    this.oldmetalSummary.total = this.summary.amount_in.total;
  }

  toggleAccordion(type: 'oldmetal') {
    this.accordionState[type] = !this.accordionState[type];
  }

  getChips(trans: any) {
    return [
      { label: 'INV No.', value: trans.invoice_no },
      { label: 'Date', value: trans.date ? trans.date.split(' ')[0] : '' },
      { label: 'Firm', value: trans.firm },
      { label: 'UserName', value: trans.user },
      { label: 'City', value: trans.city },
      { label: 'Metal Rec.', value: Math.abs(trans.cash).toFixed(2) },
      { label: 'Metal Udhar', value: Math.abs(trans.card).toFixed(2) },
      { label: 'Metal Conv.', value: Math.abs(trans.online).toFixed(2) },
      { label: 'Total Sales', value: Math.abs(trans.total).toFixed(2) },
    ];
  }
}
